"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

require("waypoints/lib/jquery.waypoints");

require("waypoints/lib/shortcuts/sticky");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Section_Nav = function Section_Nav() {
  _classCallCheck(this, Section_Nav);

  var $sectionNav = void 0;
  if ((0, _jquery2.default)(".section-nav").length) {
    $sectionNav = (0, _jquery2.default)(".section-nav");
    if ($sectionNav.length > 0) {
      new Waypoint.Sticky({
        element: $sectionNav,
        offset: "70px"
      });
      (0, _jquery2.default)("section.user-icons").waypoint({
        handler: function handler(e) {
          var current = void 0;
          current = (0, _jquery2.default)(this).attr("id");
          (0, _jquery2.default)(".section-nav .current").removeClass("current");
          return (0, _jquery2.default)(".section-nav a[href=\"#" + current + "\"]").parent("li").addClass("current");
        },
        offset: "100px"
      });
      (0, _jquery2.default)(".section-nav a").on("click", function (_ref) {
        var preventDefault = _ref.preventDefault;

        var newTop = void 0;
        var scrollTop = void 0;
        var sectionOffsetTop = void 0;
        var target = void 0;
        preventDefault;
        scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 453) {
          sectionOffsetTop = 60;
        } else if (scrollTop > 40) {
          sectionOffsetTop = 110;
        } else {
          sectionOffsetTop = 150;
        }
        (0, _jquery2.default)(".section-nav .current").removeClass("current");
        (0, _jquery2.default)(this).parent("li").addClass("current");
        if (location.pathname.replace(/^\//, "") === this.pathname.replace(/^\//, "") && location.hostname === this.hostname) {
          target = (0, _jquery2.default)(this.hash);
          target = target.length ? target : (0, _jquery2.default)("[name=" + this.hash.slice(1) + "]");
          newTop = target.offset().top;
          if (target.length) {
            (0, _jquery2.default)("html,body").animate({
              scrollTop: newTop - sectionOffsetTop
            }, 1000);
            return false;
          }
        }
      });
    }
  }
};

exports.default = Section_Nav;